var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaxSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.28338 1.07801C4.84591 -0.359338 2.51546 -0.359338 1.07811 1.07801V1.07814C-0.359369 2.51549 -0.359369 4.84594 1.07811 6.28342L9.71658 14.9219C11.1541 16.3594 13.4845 16.3594 14.922 14.9219C16.3593 13.4845 16.3593 11.1541 14.922 9.71662L6.28338 1.07801Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0781 14.9219C26.5154 16.3594 28.8461 16.3594 30.2834 14.9219L38.922 6.28341C40.3593 4.84605 40.3593 2.51548 38.922 1.07812V1.078C37.4847 -0.359354 35.1541 -0.359354 33.7168 1.07812L25.0781 9.71673C23.6406 11.1541 23.6406 13.4845 25.0781 14.9219Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2834 25.0781C28.8461 23.6406 26.5155 23.6406 25.0781 25.0781C23.6406 26.5156 23.6406 28.846 25.0781 30.2832L33.7168 38.9218C35.1541 40.3593 37.4847 40.3594 38.922 38.922V38.9218C40.3593 37.4845 40.3593 35.1539 38.922 33.7167L30.2834 25.0781Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.922 25.078C13.4845 23.6406 11.154 23.6406 9.71669 25.0781L1.07806 33.7167C-0.359293 35.154 -0.359416 37.4845 1.07806 38.9219C2.51554 40.3594 4.846 40.3594 6.28336 38.9219L14.922 30.2833C16.3593 28.8459 16.3593 26.5155 14.922 25.0781V25.078Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaxSymbol);
export default __webpack_public_path__ + "static/media/pax-symbol.ab5e5f11eefa7a8c223544c11d4aeb45.svg";
export { ForwardRef as ReactComponent };